import { useEffect } from 'react';
import type { FC } from 'react';

export type ContentBodyDynamic = {
	representation?: string | null;
	value?: string | null;
};

export type OnCurrentContentBodyDynamicChange = (
	contentBodyDynamic: ContentBodyDynamic | null | undefined,
	contentId?: string | null,
) => void;

type Props = {
	contentBodyDynamic: ContentBodyDynamic | null | undefined;
	contentId: string;
	contentIdFromQuery?: string | null;
	onCurrentContentBodyDynamicChange?: OnCurrentContentBodyDynamicChange;
};

export const CurrentContentBodyDynamicTracker: FC<Props> = ({
	contentBodyDynamic,
	contentId,
	contentIdFromQuery,
	onCurrentContentBodyDynamicChange,
}) => {
	useEffect(() => {
		const isCurrentContent = contentId === contentIdFromQuery;
		onCurrentContentBodyDynamicChange?.(
			isCurrentContent ? contentBodyDynamic : undefined,
			isCurrentContent ? contentIdFromQuery : undefined,
		);
	}, [contentBodyDynamic, contentId, contentIdFromQuery, onCurrentContentBodyDynamicChange]);

	return null;
};
